<template>
  <el-container>
    <el-header>
      <NavTop></NavTop>
    </el-header>
    <el-container>
      <el-aside class="aside">
        <LeftNav></LeftNav>
      </el-aside>
      <el-main>
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import NavTop from "/src/components/navtop/index.vue";
import LeftNav from "/src/components/nav/index.vue";
export default {
  components: {
    NavTop,
    LeftNav,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style>
.el-main {
  background-color: #f5f7f9;
}
.el-header {
  height: 70px !important;
  background-color: #cbc68d !important;
}
.el-container {
  height: 100%;
}
.aside {
  width: 240px !important;
  height: calc(100vh - 68px);
}
</style>
